import { Range } from 'slate';
export default function getCellsActiveMarks(editor, cells) {
  return cells.reduce(function (memo, cell) {
    var range = Range.create().moveToRangeOfNode(cell);
    var marks = cell.getActiveMarksAtRange(range);
    if (!memo) return marks;
    if (range.isCollapsed) return memo;
    return memo.intersect(marks);
  }, null);
}